<template>
  <div :class="{ 'recommend-disabled-card': disabled }">
    <!-- 课程名称+标签 -->
    <div class="inner-box-title">
      <!-- eslint-disable-next-line prettier/prettier -->
      <span class="inner-box-tag">{{$$(product_item.extra_info).subject_name}}</span>{{ product_item.name }}
    </div>
    <div class="course-time">{{ product_item.desc }}</div>
    <div class="course-teacher">
      <div
        v-for="(tItem, tIndex) in teacherInfoList"
        :key="tItem.id"
        :class="['flex-center-start', { 'mg-right-20': tIndex === 0 }]"
      >
        <img class="teacher-img" :src="tItem.avatar" alt="" />
        <div>
          <p class="text-1">{{ tItem.type_name }}</p>
          <p class="text-2">{{ tItem.name }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    teacherInfoList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    product_item: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
@import "../../../assets/less/layout.less";
.recommend-disabled-card {
}
.inner-box-title {
  .ellipsis-two;
  color: #333;
  text-align: justify;
  font-family: PingFang SC;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  word-break: break-all;
}
.inner-box-tag {
  position: relative;
  top: -2px;
  margin-right: 4px;
  display: initial;
  white-space: nowrap;
  padding: 0 3px;
  border-radius: 4px;
  background-color: #e4a970;
  color: #fff;
  font-family: PingFang SC;
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
}
.course-time {
  margin-top: 8px;
  color: #666;
  font-family: PingFang SC;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.course-teacher {
  .flex-center-start;
  margin-top: 8px;
}
.teacher-img {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  margin-right: 6px;
}
.text-1 {
  color: #999;
  font-family: PingFang SC;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}
.text-2 {
  .text-1;
  color: #333;
}
.mg-right-20 {
  margin-right: 20px;
}
.recommend-disabled-card {
  .teacher-img {
    opacity: 0.6;
  }
  .inner-box-tag {
    background-color: #adadad;
  }
  .inner-box-title,
  .course-time,
  .text-1,
  .text-2 {
    color: #adadad;
  }
}
</style>
